import { InjectionToken } from '@angular/core';
import { environment } from '@env/environment';

export const AUTH_API_BASE_URL = new InjectionToken<string>('AUTH_API_BASE_URL', {
    factory: () => environment.apiUrl
});
